import React from "react";

import Scooter from "components/Icons/scooter.svg";

type Props = {
  subtotal?: number | string;
  savings?: number | string | null;
  freeDeliveryMinimum?: number | null;
};

const FreeDeliveryStatus: React.FC<Props> = ({
  subtotal,
  savings,
  freeDeliveryMinimum,
}) => {
  const amountShortOfFreeDelivery =
    Number(freeDeliveryMinimum) - (Number(subtotal) - Number(savings));
  const hasMetDeliveryMinimum = amountShortOfFreeDelivery <= 0;
  return (
    <div
      className="text-xs font-extrabold text-notification flex gap-4"
      data-testid="free-delivery-banner"
    >
      <Scooter height="16" width="16" className="text-notification" />
      {hasMetDeliveryMinimum ? (
        <span className="align-middle" data-testid="delivery-minimum-met">
          CONGRATS! YOU UNLOCKED FREE DELIVERY!
        </span>
      ) : (
        <span className="align-middle" data-testid="add-for-delivery">
          ADD{" "}
          <span data-testid="delivery-shortage">
            ${amountShortOfFreeDelivery.toFixed(2)}
          </span>{" "}
          FOR FREE DELIVERY!
        </span>
      )}
    </div>
  );
};

export default FreeDeliveryStatus;
